"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const TabGroup = ({ label, children }) => (react_1.default.createElement("div", { className: "tab-group" },
    react_1.default.createElement("h6", null, label),
    children));
TabGroup.propTypes = {
    label: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.node,
};
exports.default = TabGroup;
